import { useEffect } from 'react';
import {
  setUserLocation,
  toTrackingUserLocation,
} from '../../features/tracking/tracking.slice';
import { getUserLocation } from '../../features/tracking/tracking.selectors';
import { fetchUserLocationDetails } from '../../services/users/fetchUserLocationDetails';
import { useAppDispatch, useAppSelector } from '../useReduxToolkit';

/**
 * Prefetch geolocation from api-core's public `users/userLocationDetails` REST
 * endpoint once per app shell. Consumed by `segmentTracker` as
 * `context.ip_geolocation` on Segment track calls.
 *
 * Tracking-only: check-in and onboarding continue to use OG via
 * `UsersService.fetchLocationDetails`.
 */
export const useTrackUserLocation = (): void => {
  const dispatch = useAppDispatch();
  const cachedLocation = useAppSelector(getUserLocation);

  useEffect(() => {
    if (cachedLocation !== null) return;

    let cancelled = false;
    void (async () => {
      try {
        const locationDetails = await fetchUserLocationDetails();
        if (cancelled || locationDetails === null) return;
        dispatch(setUserLocation(toTrackingUserLocation(locationDetails)));
      } catch {
        // Location is best-effort for analytics; ignore fetch failures.
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [cachedLocation, dispatch]);
};
